'use strict';
var _ = require('lodash');
var Mapper = require('./Mapper.js');
var Products = require('./Products.js');
var Formatter = require('./Formatter.js');
var Validators = require('./Validators.js');

var AppConstants = require('../constants/ApplicationConstants');
var ProductIds = AppConstants.ProductIds;
var FundingYourProductConstants = require('../constants/FundingYourProductConstants');
var RollOverTypes = FundingYourProductConstants.RollOverTypes;
var HowMuchToRollOver = FundingYourProductConstants.HowMuchToRollOver;
var MinimumBalance = FundingYourProductConstants.MinimumBalance;
var InternalRolloverFieldMapping = FundingYourProductConstants.InternalRolloverFieldMapping;
var ExternalRolloverFieldMapping = FundingYourProductConstants.ExternalRolloverFieldMapping;
var NonRolloverFieldMapping = FundingYourProductConstants.NonRolloverFieldMapping;
var DirectDebitFieldMapping = FundingYourProductConstants.DirectDebitFieldMapping;
var MinimumAmounts = FundingYourProductConstants.MinimumAmounts;
var ContentService = require('../services/ContentService');

module.exports = {
    //rollover amount validation rules are: 
    //currency only when when the rollover type is internal/external and 
    //the partial rollover type question is not answered or the answer to that question is entire balance
    //required and currency when the rollover type is internal/external and the partial rollover type question 
    //is answered with enter amount or leave amount and there is remaining balance question is not yet answered
    //required, currency and the it's value should not be greater than or equal to the entered remaining balance 
    //when the rollover type is internal/external, the answer to the partial rollover question is enter/leave amount and 
    //there is an answer to the remaining balance question
    getRollOverAmountRule: function (rollOverType, dataToValidate) {
        var maintainingBalance = (dataToValidate.productId !== FundingYourProductConstants.ManualEntryInternalRolloverId) ? MinimumBalance[dataToValidate.productId] : MinimumBalance[dataToValidate.selectedManualEntryProductId];
        if (!this.isNonRollover(rollOverType) && (dataToValidate.partialRolloverType === HowMuchToRollOver.ENTIRE_BALANCE || dataToValidate.partialRolloverType === '')) {
            return false;
        }
        else if (!this.isNonRollover(rollOverType) && (dataToValidate.paymentMethod !== FundingYourProductConstants.internalTransfer) &&
                    (dataToValidate.partialRolloverType === HowMuchToRollOver.ENTER_AMOUNT || dataToValidate.partialRolloverType === HowMuchToRollOver.LEAVE_AMOUNT) &&
                    (dataToValidate.remainingBalance === '' || !Validators.currencyValidation(dataToValidate.remainingBalance))) {
            return 'required|currency|amountMustNotBeZero|currencyMaxLength';
        }
        else if (dataToValidate.rollOverName !== '' && rollOverType === RollOverTypes.INTERNAL && dataToValidate.partialRolloverType === HowMuchToRollOver.ENTER_AMOUNT) {
            return Formatter.formatString('required|currency|amountMustNotBeZero|amountMustNotBeEqualToBalance:{{balance}}|amountMustBeLessThanBalance:{{balance}}|currencyMaxLength', { balance: dataToValidate.remainingBalance });
        }
        else if (dataToValidate.rollOverName !== '' && rollOverType === RollOverTypes.INTERNAL && dataToValidate.partialRolloverType === HowMuchToRollOver.LEAVE_AMOUNT) {
            return Formatter.formatString('required|currency|amountMustNotBeZero|amountMustBeGreaterThanMaintaining:{{maintainingBalance}}|amountMustNotBeEqualToBalance:{{balance}}|amountMustBeLessThanBalance:{{balance}}|currencyMaxLength', { balance: dataToValidate.remainingBalance, maintainingBalance: maintainingBalance });
        }
        return Formatter.formatString('required|currency|amountMustNotBeZero|amountMustNotBeEqualToBalance:{{balance}}|amountMustBeLessThanBalance:{{balance}}|currencyMaxLength', { balance: dataToValidate.remainingBalance });
    },
    //entire balance question is required only if the application is for the superannuation product
    //and the selected internal rollover is from an existing super product
    //and the selected partial rollover type is entire balance
    getEntireBalanceQuestionRule: function (rollOverType, productId, dataToValidate) {
        if (rollOverType === RollOverTypes.INTERNAL) {
            if (productId && productId === ProductIds.SUPER) {
                var isSuper = _.find(FundingYourProductConstants.SuperProducts, { value: dataToValidate.rollOverName });
                if (isSuper && dataToValidate.partialRolloverType === HowMuchToRollOver.ENTIRE_BALANCE) {
                    return 'required';
                }
            }
        }
        return false;
    },
    //account number validations depend on the rollover type
    getAccountNumberRule: function (rollOverType) {
        switch (rollOverType) {
            case RollOverTypes.EXTERNAL:
                return 'alphaNumWithSpaces|maxLength:15';
            case RollOverTypes.INTERNAL:
                return 'required|alphaNumWithSpaces|between:12,15';
            case RollOverTypes.NON_ROLLOVER:
                return 'required';
            default:
                return 'alphaNum';
        }
    },

    balanceMustBeGreaterThanMaintaining: function (dataToValidate, rollOverType, inlineErrorList) {
        if (this.checkIfErrorExists(inlineErrorList, 'rollOverAmount')) {
            return true;
        }
        if (dataToValidate.rollOverName !== '' && rollOverType === RollOverTypes.INTERNAL && dataToValidate.partialRolloverType === HowMuchToRollOver.ENTER_AMOUNT) {
            var maintainingBalance = (dataToValidate.productId !== FundingYourProductConstants.ManualEntryInternalRolloverId) ? MinimumBalance[dataToValidate.productId] : MinimumBalance[dataToValidate.selectedManualEntryProductId];
            var balance = parseFloat(dataToValidate.remainingBalance.replace(/,/g, ''));
            var amount = parseFloat(dataToValidate.rollOverAmount.replace(/,/g, ''));
            var remaining = (balance - amount);
            if (remaining < parseFloat(maintainingBalance)) {
                return false;
            }
        }
        return true;
    },

    performBalanceAndAmountValidation: function (rollOver, dataToValidate, rollOverType, inlineErrorList, summaryErrorList, validateForm, label) {
        var maintainingBalance = (dataToValidate.productId !== FundingYourProductConstants.ManualEntryInternalRolloverId) ? MinimumBalance[dataToValidate.productId] : MinimumBalance[dataToValidate.selectedManualEntryProductId];
        var inlineErrorMessages = ContentService.getContent().inlineErrorMessages;
        var summaryErrorMessages = ContentService.getContent().summaryErrorMessages;
        if (!this.balanceMustBeGreaterThanMaintaining(dataToValidate, rollOverType, inlineErrorList) && rollOver !== RollOverTypes.NON_ROLLOVER) {
            inlineErrorList.push({ id: 'rollOverAmount', message: Formatter.formatString(inlineErrorMessages.balanceMustBeGreaterThanMaintaining, { maintainingBalance: maintainingBalance }), type: AppConstants.messageTypes.error });
            if (validateForm) {
                summaryErrorList.push({ id: 'rollOverAmount', clickable: label, message: summaryErrorMessages.balanceMustBeGreaterThanMaintaining });
            }
        } else {
            this.clearSpecificError(dataToValidate.errorList, 'rollOverAmount', inlineErrorMessages.balanceMustBeGreaterThanMaintaining, rollOverType, false);
        }
    },
    validateAccountNumber: function (rollOverType, accountNumber) {
        var rule = { data: this.getAccountNumberRule(rollOverType) };
        var data = { data: accountNumber };
        var attributeName = { data: 'data' };
        var errorList = [];
        var validator = Validators.validateField(data, rule, attributeName, errorList, 'data');
        var result = validator.passes();
        return result;
    },

    rollOverLimitValidation: function (rollOverType, summaryList, inlineErrorList, summaryErrorList, validateForm, label) {
        var internalCount = _.where(summaryList, { rollOverType: RollOverTypes.INTERNAL });
        var externalCount = _.where(summaryList, { rollOverType: RollOverTypes.EXTERNAL });
        var isFundingExceeds = internalCount.length + externalCount.length;
        if ((rollOverType === RollOverTypes.EXTERNAL || rollOverType === RollOverTypes.INTERNAL) && isFundingExceeds >= 20) {
            var copyText = ContentService.getContent().fundingYourProduct;
            inlineErrorList.push({ id: 'maxRolloversReached', message: copyText.inlineFundingCountErrorMessage, type: AppConstants.messageTypes.error });
            if (validateForm) {
                summaryErrorList.push({ id: 'maxRolloversReachedClickable', clickable: label, message: copyText.summaryFundingCountErrorMessage });
            }
        }
    },

    duplicateAccountChecks: function (rollOver, summaryList, internalAccounts, dataToValidate, rollOverType, inlineErrorList, summaryErrorList, validateForm, isEdit, label) {
        if (rollOver !== RollOverTypes.NON_ROLLOVER) {
            var copyText = ContentService.getContent().fundingYourProduct;
            //perform duplicate account number validation in manual entry over summary
            if (summaryList.length > 0) {
                if (this.checkForDuplicateAccountNumbersInSummary(dataToValidate, summaryList, isEdit, inlineErrorList)) {
                    inlineErrorList.push({ id: 'accountNumber', message: copyText.inlineDuplicateAccountNumberError, type: AppConstants.messageTypes.error });
                    if (validateForm) {
                        summaryErrorList.push({ id: 'accountNumber', clickable: label, message: copyText.summaryDuplicateAccountNumberError });
                    }
                } else {
                    this.clearSpecificError(dataToValidate.errorList, 'accountNumber', copyText.inlineDuplicateAccountNumberError, rollOverType, false)
                }
            }
            //perform duplicate account number validation in manual entry over existing accounts
            if (this.checkForDuplicateAccountsInExistingAccounts(dataToValidate, rollOverType, internalAccounts, inlineErrorList)) {
                inlineErrorList.push({ id: 'accountNumber', message: copyText.inlineDuplicateExistingAccountNumberError, type: AppConstants.messageTypes.error });
                if (validateForm) {
                    summaryErrorList.push({ id: 'accountNumber', clickable: label, message: copyText.summaryDuplicateAccountNumberError });
                }
            } else {
                this.clearSpecificError(dataToValidate.errorList, 'accountNumber', copyText.inlineDuplicateExistingAccountNumberError, rollOverType, false);
            }
        }
    },

    checkForDuplicateAccountsInExistingAccounts: function (dataToValidate, rollOverType, internalAccounts, inlineErrorList) {
        if (this.checkIfErrorExists(inlineErrorList, 'accountNumber')) {
            return false;
        }
        var accountNumber = Formatter.removeSpaces(dataToValidate.accountNumber);
        var tempInternalAccounts = _.cloneDeep(internalAccounts);
        var rollOverName = dataToValidate.rollOverName ? Formatter.removeSpaces(dataToValidate.rollOverName.toLowerCase()) : null;

        if (dataToValidate.productId === FundingYourProductConstants.ManualEntryInternalRolloverId || rollOverType === RollOverTypes.EXTERNAL) {
            _.forEach(tempInternalAccounts, function (o) {
                o.accountNumber = Formatter.removeSpaces(o.accountNumber);
                o.productName = Formatter.removeSpaces(o.productName.toLowerCase());
            });
            var result = _.find(tempInternalAccounts, function (o) {
                return o.accountNumber === accountNumber &&
                       (o.productName === rollOverName || o.id === dataToValidate.selectedManualEntryProductId);
            });
            if (result) {
                return true;
            }
        }
        return false;
    },

    checkForDuplicateAccountNumbersInSummary: function (dataToValidate, summaryList, isEdit, inlineErrorList) {
        if (this.checkIfErrorExists(inlineErrorList, 'accountNumber')) {
            return false;
        }
        var accountNumber = Formatter.removeSpaces(dataToValidate.accountNumber);
        var rollOverName = dataToValidate.rollOverName ? Formatter.removeSpaces(dataToValidate.rollOverName.toLowerCase()) : null;
        var tempSummary = _.cloneDeep(summaryList);
        var productId = dataToValidate.productId === FundingYourProductConstants.ManualEntryInternalRolloverId ? dataToValidate.selectedManualEntryProductId : dataToValidate.productId;
        if (!dataToValidate.isExistingAccount) {
            _.forEach(tempSummary, function (o) {
                o.accountNumber = Formatter.removeSpaces(o.accountNumber);
                o.rollOverName = Formatter.removeSpaces(o.rollOverName.toLowerCase());
            });
            var checkIfDuplicateNameExists = this.checkIfDuplicateNameExists;
            var checkIfDuplicateProductIdExists = this.checkIfDuplicateProductIdExists;
            var isNonRollOver = this.isNonRollover;
            if (!isEdit) {
                var result = _.find(tempSummary, function (o) {
                    return !isNonRollOver(o.rollOverType) &&
                        (checkIfDuplicateNameExists(o, rollOverName, accountNumber) ||
                            checkIfDuplicateProductIdExists(o, productId, accountNumber));
                });
                if (result) {
                    return true;
                }
            } else {
                var editResult = _.find(tempSummary, function (o) {
                    return o.summaryIndex !== dataToValidate.summaryIndex &&
                        !isNonRollOver(o.rollOverType) &&
                        (checkIfDuplicateNameExists(o, rollOverName, accountNumber) ||
                            checkIfDuplicateProductIdExists(o, productId, accountNumber));
                });
                if (editResult) {
                    return true;
                }
            }
        }
        return false;
    },

    mapInlineErrorList: function (errorList, rollOverType, isDirectDebit) {
        var getFieldMapping = this.getFieldMapping;
        if (errorList && errorList.length > 0) {
            _.forEach(errorList, function (n) {
                n.id = getFieldMapping(rollOverType, n.id, isDirectDebit);
            });
        }
        return errorList;
    },

    mapSummaryErrorList: function (sectionErrorList, errorList, validateForm, sectionName, rollOverType, isDirectDebit) {
        var getFieldMapping = this.getFieldMapping;
        if (validateForm && errorList.length > 0) {
            _.forEach(errorList, function (n) {
                sectionErrorList.push({
                    clickable: sectionName, message: n.message, id: getFieldMapping(rollOverType, n.id, isDirectDebit)
                });
            });
        }
    },

    getFieldMapping: function (rollOverType, id, isDirectDebit) {
        switch (rollOverType) {
            case RollOverTypes.INTERNAL:
                return InternalRolloverFieldMapping[id];
            case RollOverTypes.EXTERNAL:
                return ExternalRolloverFieldMapping[id];
            case RollOverTypes.NON_ROLLOVER:
                if (isDirectDebit) {
                    return DirectDebitFieldMapping[id];
                }
                return NonRolloverFieldMapping[id];
            default:
                return ExternalRolloverFieldMapping[id];
        }
    },

    sortSummaryErrorMessages: function (summaryErrorMessages) {
        if (summaryErrorMessages.length > 0) {
            var copyText = ContentService.getContent().fundingYourProduct;
            var duplicateAccountError = Mapper.getObjectByAttribute(summaryErrorMessages, copyText.summaryDuplicateAccountNumberError, 'message');
            if (duplicateAccountError) {
                _.remove(summaryErrorMessages, { message: duplicateAccountError.message });
                var newList = [];
                newList = newList.concat(duplicateAccountError, summaryErrorMessages);
                return newList;
            } else {
                return summaryErrorMessages;
            }
        } else {
            return [];
        }
    },

    isNonRollover: function (rolloverType) {
        if (rolloverType === RollOverTypes.INTERNAL || rolloverType === RollOverTypes.EXTERNAL) {
            return false;
        }
        return true;
    },

    isInternal: function (fundingType) {
        if (fundingType === RollOverTypes.INTERNAL || fundingType === FundingYourProductConstants.ContributionValues.INTERNAL_TRANSFER) {
            return true;
        }
        return false;
    },

    isNominatedDirectDebit: function (dataToValidate) {
        return dataToValidate.paymentMethod === FundingYourProductConstants.ContributionValues.DIRECT_D && dataToValidate.bankAccountId === FundingYourProductConstants.NominateBankAccountId;
    },

    isDirectDebit: function (dataToValidate) {
        return dataToValidate.paymentMethod === FundingYourProductConstants.ContributionValues.DIRECT_D;
    },

    getBankAccountNumberRule: function (dataToValidate) {
        if (this.isNominatedDirectDebit(dataToValidate)) {
            return 'alphaNumWithSpaces|maxLength:9';
        } else {
            return false;
        }
    },

    getAccountHolderNameRule: function (dataToValidate) {
        if (this.isNominatedDirectDebit(dataToValidate)) {
            return 'nameWithNumSpaces|maxLength:30';
        } else {
            return false;
        }
    },

    getBsbRule: function (dataToValidate) {
        if (this.isNominatedDirectDebit(dataToValidate)) {
            return 'numeric2|exactLength:6';
        } else {
            return false;
        }
    },

    getRollOverAmountRuleForNonRollover: function (dataToValidate) {
        if (Validators.requiredValidation(dataToValidate.paymentMethod)) {
            return 'required|currency|amountMustNotBeZero|currencyMaxLength';
        } else {
            return false;
        }
    },

    directDebitValidation: function (dataToValidate, isDirectDebit, summaryErrorList, validateForm, label) {
        if (isDirectDebit && !Validators.requiredValidation(dataToValidate.bankAccountId)) {
            var copyText = ContentService.getContent().fundingYourProduct;
            dataToValidate.hideBankAccountListValid = false;
            if (validateForm) {
                summaryErrorList.push({ id: 'invalidBankAccountListError', clickable: label, message: copyText.listBankAccountSummary });
            }
        }
        else {
            dataToValidate.hideBankAccountListValid = true;
        }
    },

    getValidationRules: function (rollOverType, fieldId, dataToValidate, productId, activeFundType) {
        var allRules = rollOverType === RollOverTypes.NON_ROLLOVER
            ? this.getNonRollOverRules(productId, activeFundType, dataToValidate)
            : this.getRollOverRules(rollOverType, productId, dataToValidate);

        if (!fieldId) {
            return allRules;
        }

        if (!allRules[fieldId]) {
            return null;
        }

        var rulesForField = {};
        rulesForField[fieldId] = allRules[fieldId];
        return rulesForField;
    },

    getNonRollOverRules: function (productId, activeFundType, dataToValidate) {
        return {
            paymentMethod: 'required',
            claimTaxDeduction: this.getClaimTaxDeductionRule(productId, activeFundType, dataToValidate),
            rollOverAmount: this.getRollOverAmountRuleForNonRollover(dataToValidate),
            accountHolderName: this.getAccountHolderNameRule(dataToValidate),
            bankAccountHeldOption: false,
            branchNumber: this.getBsbRule(dataToValidate),
            accountNumber: this.getBankAccountNumberRule(dataToValidate),
            startDate: 'dateInvalidFormat|shouldBeFutureDate'
        };
    },

    getRollOverRules: function (rollOverType, productId, dataToValidate) {
        return {
            rollOverNamePredictive: this.getRollOverNamePredictiveRules(rollOverType, dataToValidate),
            rollOverName: this.getRolloverNameRules(productId, rollOverType, dataToValidate),
            usi: dataToValidate.isExternalProviderManualEntry ? 'alphaNum|between:9,14' : false,
            accountNumber: this.getAccountNumberRule(rollOverType),
            remainingBalance: 'required|currency|balanceMustNotBeZero|currencyMaxLength',
            partialRolloverType: 'required',
            entireBalanceQuestion: this.getEntireBalanceQuestionRule(rollOverType, productId, dataToValidate),
            rollOverAmount: this.getRollOverAmountRule(rollOverType, dataToValidate),
            otherInvestmentOption: 'maxLength:255'
        };
    },

    checkIfDirectDebitExists: function (summaryList) {
        var directDebitExists = Mapper.getObjectByAttribute(summaryList, FundingYourProductConstants.ContributionValues.DIRECT_D, 'paymentMethod');
        if (directDebitExists) {
            return true;
        } else {
            return false;
        }
    },

    removeDirectDebitFromSummary: function (indexToDelete, summaryList) {
        var isFirstDirectDebit = false;
        if (summaryList[indexToDelete].hideDirectDebitAddedText) {
            isFirstDirectDebit = true;
        }
        summaryList.splice(indexToDelete, 1); //delete
        summaryList = this.updateSummaryIndex(summaryList);
        if (isFirstDirectDebit) {
            return this.updateHideShowDirectDebitAddedText(summaryList);
        }
        return summaryList;

    },

    updateHideShowDirectDebitAddedText: function (summaryList) {
        var firstDirectDebit = true;
        for (var i = 0; i < summaryList.length; i++) {
            if (this.isDirectDebit(summaryList[i]) && firstDirectDebit) {
                summaryList[i].hideDirectDebitAddedText = true;
                if (summaryList[i].bankAccountId === FundingYourProductConstants.NominateBankAccountId) {
                    summaryList[i].showDdNominateAccount = true;
                } else {
                    summaryList[i].showDdNominateAccount = false;
                }
                summaryList[i].showDdDetails = true;
                firstDirectDebit = false;
            } else if (this.isDirectDebit(summaryList[i])) {
                summaryList[i].hideDirectDebitAddedText = false;
            }
        }
        return summaryList;
    },

    updateSummaryIndex: function (summaryList) {
        for (var i = 0; i < summaryList.length; i++) {
            summaryList[i].summaryIndex = i;
        }
        return summaryList;
    },

    clearSpecificError: function (errorList, fieldId, errorMessage, rollOver, isDirectDebit) {
        var duplicateErrorMessageId = this.getFieldMapping(rollOver, fieldId, isDirectDebit);
        var existingDuplicateAccountError = _.find(errorList, { 'id': duplicateErrorMessageId, 'message': errorMessage });
        if (existingDuplicateAccountError) {
            Validators.clearErrorListForField(errorList, duplicateErrorMessageId);
        }
    },

    checkIfErrorExists: function (inlineErrorList, errorIdToFind) {
        var existingAccountInInline = Mapper.getObjectByAttribute(inlineErrorList, errorIdToFind, 'id');
        if (existingAccountInInline) {
            return true;
        }
        return false;
    },
    checkIfDuplicateNameExists: function (fundingToCheck, newRollOverName, newAccountNumber) {
        return fundingToCheck.rollOverName === newRollOverName && fundingToCheck.accountNumber === newAccountNumber;// && fundingToCheck.rollOverType === RollOverTypes.EXTERNAL;
    },
    checkIfDuplicateProductIdExists: function (fundingToCheck, newRollOverProductId, newAccountNumber) {
        return ((fundingToCheck.selectedManualEntryProductId === newRollOverProductId &&
                fundingToCheck.productId === FundingYourProductConstants.ManualEntryInternalRolloverId) ||
            (fundingToCheck.productId !== FundingYourProductConstants.ManualEntryInternalRolloverId &&
                fundingToCheck.productId === newRollOverProductId && fundingToCheck.rollOverType === RollOverTypes.INTERNAL)) &&
            fundingToCheck.accountNumber === newAccountNumber;
    },


    getRolloverNameRules: function (productId, type, data) {
        if (Products.isInvestment(productId)) {
            return 'required|atLeastOneAlpha';
        }
        else {
            if (type === RollOverTypes.EXTERNAL && !data.isExternalProviderManualEntry) {
                return false;
            }
            return 'required|maxLength:30|atLeastOneAlpha';
        }
    },

    validateTotals: function (total, productId, withRIP, sectionLabel) {
        var minimum = 0;
        if (Products.isPension(productId)) {
            minimum = MinimumAmounts.pension;
        } else {
            if (withRIP === AppConstants.YesNoValues.YES) {
                minimum = MinimumAmounts.investmentWithRip;
            } else {
                minimum = MinimumAmounts.investmentNoRip;
            }
        }
        var data = { fundingYourProductSection: total };
        var attributeNames = { fundingYourProductSection: 'total' };
        var rule = { fundingYourProductSection: 'amountMustBeGreaterThanMinimum:' + minimum };
        var newErrorList = Validators.validateAll(data, rule, attributeNames);
        var newSummaryErrorList = Validators.validateAll(data, rule, attributeNames, '', sectionLabel);
        return { newErrorList: newErrorList, newSummaryErrorList: newSummaryErrorList }
    },

    isExternal: function (fundingType) {
        if (fundingType === RollOverTypes.EXTERNAL) {
            return true;
        }
        return false;
    },

    getRollOverNamePredictiveRules: function (rollOverType, dataToValidate) {
        if (this.isInternal(rollOverType) || (this.isExternal(rollOverType) && dataToValidate.isExternalProviderManualEntry)) {
            return false;
        }
        else {
            return 'required';
        }
    },
    getClaimTaxDeductionRule: function (productId, activeFundType, dataToValidate) {
        if (Products.isPension(productId) && activeFundType === FundingYourProductConstants.FundingTypes.Personal_contribution && dataToValidate.paymentMethod !== '') {
            return 'required';
        }
        else {
            return false;
        }
    },

    checkInvestmentNumberOfFundingSources:function(productId, summaryList, inlineErrorList, summaryErrorList, validateForm, label) {
        if (Products.isInvestment(productId) && summaryList.length >= 1) {
            var copyText = ContentService.getContent().fundingYourProduct;
            inlineErrorList.push({ id: 'maxRolloversReached', message: copyText.oneFundingSourceInvestmentInline, type: AppConstants.messageTypes.error });
            if (validateForm) {
                summaryErrorList.push({ id: 'maxRolloversReachedClickable', clickable: label, message: copyText.oneFundingSourceInvestmentSummary });
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/FundingYourProductHelper.js